import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Route from "./route";
import { theme } from "./config/mui-theme";
import { ThemeProvider } from "@mui/material";
import { LanguageProvider } from "./context/LanguageContext";
import axios from "axios";
import { history } from "./lib/history";
import { getFilteredData } from "./lib/helper";

axios.interceptors.request.use(
  (config) => {
    let request = config;
    request.url = config.url;
    return request;
  },
  (error) => error
);

axios.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      handleInvalidToken();
    }
    throw error;
  }
);

const handleInvalidToken = () => {
  localStorage.clear();
  history.navigate("/login");
  //TODO: Handle invalid token
  // removeStoreItem(Authentication.TOKEN);
  // ApiConfig.token = null as any;
  // showToast('Token expired. Please log in again.');
  // DeviceEventEmitter.emit(Authentication.REDIRECT_LOGIN);
};

function HistorySetter() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    history.navigate = navigate;
    history.location = location;
  }, [navigate, location]);

  return null; // No UI
}

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <LanguageProvider>
          <Router>
            <HistorySetter />
            <Route />
          </Router>
        </LanguageProvider>
      </ThemeProvider>
    </>
  );
}

export default App;